import { TooltipV2 } from '@cimplico/components';
import {
    MinusCircleIcon,
    EllipsisHorizontalCircleIcon,
    ExclamationCircleIcon,
    CheckCircleIcon,
    XCircleIcon,
} from '@heroicons/react/24/solid';
import { WorksheetStatusEnum } from '../../types/worksheet';

type WorksheetStatusIconProps = {
    status: WorksheetStatusEnum;
    smallIcon?: boolean;
};

export function WorksheetStatusIcon({ status, smallIcon = false }: WorksheetStatusIconProps): JSX.Element {
    return (
        <div>
            {status === WorksheetStatusEnum.UNPREPARED && (
                <TooltipV2 position="left" message="Unprepared">
                    <MinusCircleIcon className={`${smallIcon ? 'h-4 w-4' : 'h-5 w-5'} text-red-600 dark:text-red-500`} />
                </TooltipV2>
            )}
            {status === WorksheetStatusEnum.IN_PROGRESS && (
                <TooltipV2 position="left" message="In Progress">
                    <EllipsisHorizontalCircleIcon className={`${smallIcon ? 'h-4 w-4' : 'h-5 w-5'} text-yellow-500 dark:text-yellow-500`} />
                </TooltipV2>
            )}
            {status === WorksheetStatusEnum.AWAITING_REVIEW && (
                <TooltipV2 position="left" message="Awaiting Review">
                    <ExclamationCircleIcon className={`${smallIcon ? 'h-4 w-4' : 'h-5 w-5'} text-blue-500 dark:text-blue-500`} />
                </TooltipV2>
            )}
            {status === WorksheetStatusEnum.REVIEWED && (
                <TooltipV2 position="left" message="Reviewed">
                    <CheckCircleIcon className={`${smallIcon ? 'h-4 w-4' : 'h-5 w-5'}  text-green-600 dark:text-green-500`} />
                </TooltipV2>
            )}
            {status === WorksheetStatusEnum.EXCLUDED && (
                <TooltipV2 position="left" message="Excluded">
                    <XCircleIcon className={`${smallIcon ? 'h-4 w-4' : 'h-5 w-5'} text-gray-600 dark:text-gray-500`} />
                </TooltipV2>
            )}
        </div>
    );
}
